<template>
  <nav class="v-sub-nav" :class="{menuIsOpen: isOpen}">
    <div class="menu-block-container">  
    <div class="menu-nav" @click="toggleMenu()" v-if="menuSlotIsPresent">
      <slot name="menu"></slot>
    </div>
      <div class="menu-block menu-block-left" @click="toggleMenu()">
        <slot name="left"></slot>
        <v-icon class="menu-block-arrow" icon="chevron-down" :ratio="0.5"></v-icon>
      </div>
      <div class="menu-block menu-block-right">
        <slot name="right"></slot>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "v-sub-nav",
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    }
  },
  computed: {
    menuSlotIsPresent() {
      return !!this.$slots.menu?.text.length;
    }
  },
  created() {
    this.$on("active", isOpen => {
      this.isOpen = isOpen;
    });
  },
};
</script>

<style lang="scss">
@import "../../design/variables.scss";
.v-nav-container{
  width: 100%;
}

.v-sub-nav {
  position: relative;
  position: sticky;
  top: 0;
  background-color:map-deep-get($colors, "background", "dark");
  width: 100%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  font-size: 1rem;
  padding: 0 10px;
  color:map-deep-get($colors, "foreground", "inverted");
  
  .menu-block-arrow{  
    display: none;
  }

  .menu-block-container {
    z-index: 692;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
  }

  .menu-block {
    display: flex;
    align-self: stretch;
    align-items: center;
   
  }

  .menu-block-left & {
    left: 0;
    .v-nav-item{
      background-color:map-deep-get($colors, "background", "dark");
    }
    
  }
  .menu-block-right & {
    right: 0;
  }

  .v-nav-item-title {
    padding-top: 13px;
    padding-bottom: 13px;
    a {
      font-size: 15px;
      display: block;
    }
  }
  
  .v-nav-item{
    &:hover .v-nav-item-title, &.active-exact .v-nav-item-title{
      border-bottom: 2px solid map-deep-get($colors, "foreground", "inverted");
    }
  }
}
@media screen and (max-width: $grid-tablet-breakpoint){
  .v-sub-nav {
    position: sticky;
    top: 0px;
    width: 100%;
    padding: 0px;

    .v-nav-item {
      .v-nav-item-title {
        a {
          display: block;
          flex-grow: 1;
        }
      }
      &:hover .v-nav-item-title {
        border-bottom: none
      }
      &.active-exact .v-nav-item-title {
        border-bottom: none;
        font-weight: 500;
      }
      &.theme-dark {
        .v-nav-item-title {
          color: map-deep-get($colors, "foreground", "primary");
          // Dropdown
          
          // Link
          > a {
            color: map-deep-get($colors, "foreground", "primary");
          }
          .v-icon {
            color: map-deep-get($colors, "foreground", "primary");
          }
        }
      }
    }
    .menu-block {
      flex-direction: row;
      padding-left: 10px;
    }
    
    &.menuIsOpen{
      .v-icon.menu-block-arrow svg{
        transform: rotate(180deg);
      }
    }

    .menu-block-arrow{
      flex-grow: 0;
      align-self: stretch;
      padding: 0 30px;
      display: flex;
      cursor: pointer;
      width: auto !important;
      height: auto !important;
    }

    .menu-block-container{ 
    
      width: 100%;
      position: relative;
      top: 0px;
      left: 0px;
      right: 0px;
      flex-direction: column;
      align-items: stretch;
      justify-content: stretch;
      align-content: start;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .menu-block-left {
      .theme-dark.v-nav-item:first-child{
        flex-grow: 1;
        cursor: pointer;
        border-bottom: none;
        background-color:map-deep-get($colors, "background", "dark");
        .v-nav-item-title{
          color: map-deep-get($colors, "foreground", "inverted"); 
           > a {
            
            color: map-deep-get($colors, "foreground", "inverted");
          }
          .v-icon {
            color: map-deep-get($colors, "foreground", "inverted");
          }  
        }
       
      }
    } 
    .menu-block-right{ 
      display: none;
      background-color: map-deep-get($colors, "foreground", "inverted");     
      color: map-deep-get($colors, "foreground", "primary");
      height: 100vh;
      width: 100%;
      flex-direction: column;
      align-items: stretch;
      justify-content: stretch;
      align-content: start;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    &.menuIsOpen .menu-block-right{
      display: flex;
    }

    &.isOpen .v-dropdown-content {
      margin-left: 0%;
    }

    .v-dropdown-content {
      transform-origin: top center;
      transition: margin 0.25s ease-in-out;
      position: absolute;
      left: 0;
      right: 0;
      margin-left: 100%;

      ul{
        columns: unset !important;
      }
    }
  } 
}
</style>
